import React, { useState, useRef } from 'react';

import { Modal, Button, Form, Select, Spin, Badge } from 'antd';
import { rabbitSignFieldTypes } from './../../../../../../../shared/constants/enums';
import { getRabbitSignClientOptions, getNewRabbitSignField } from './../../../../../../../shared/utils';

import { maxBy } from 'lodash';

const EditSettingsModal = ({
  rootContainer,
  open,
  fields,
  setFields,
  pageHeights,
  currentFileIndex,
  currentPageNumber,
  isNew,
  currentField,
  handleClose,
  emails,
}) => {
  const editForm = useRef(null);

  const [loading, setLoading] = useState(false);

  const addNewField = (email, fieldType, currentValue) => {
    const pageHeightSum = pageHeights.slice(0, currentPageNumber - 1).reduce((sum, height) => sum + height, 0);

    const lastDrawId = maxBy(fields, 'drawId')?.drawId || 0;

    const signer = emails.find((obj) => obj.email === email);

    const newField = getNewRabbitSignField(
      currentField,
      lastDrawId + 1,
      currentFileIndex,
      currentPageNumber,
      pageHeightSum,
      fieldType,
      currentValue,
      signer,
    );

    setFields((prevFields) => [...prevFields, newField]);
  };

  const editField = (email, fieldType, currentValue) => {
    const signerContactType = emails.find((obj) => obj.email === email)?.contactType;

    const propsToOverride = {
      email: email,
      contactType: signerContactType,
      fieldType: fieldType,
      currentValue: currentValue,
    };

    setFields((prevFields) => prevFields.map((field) => (field.drawId === currentField.drawId ? { ...field, ...propsToOverride } : field)));
  };

  const handleOkClick = () => {
    setLoading(true);

    editForm.current
      .validateFields()
      .then((values) => {
        if (isNew === true) {
          addNewField(values.email, values.fieldType, values.currentValue);
        } else {
          editField(values.email, values.fieldType, values.currentValue);
        }

        setLoading(false);

        handleClose();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => {
    handleClose();
  };

  return (
    <Modal
      destroyOnClose={true}
      title="Field Configuration"
      open={open}
      onOk={handleOkClick}
      onCancel={handleCancel}
      okText="Save"
      cancelText="Close"
      okButtonProps={{ size: 'middle' }}
      cancelButtonProps={{ size: 'middle' }}
      getContainer={rootContainer}
      className="edit-field-modal"
      footer={[
        <Button key="close" type="primary" onClick={handleCancel}>
          Close
        </Button>,
        <Button key="submit" type="primary" onClick={handleOkClick} disabled={false}>
          Save
        </Button>,
      ]}
    >
      <Spin spinning={loading}>
        <Form
          ref={editForm}
          layout="horizontal"
          name="editField"
          size="small"
          labelAlign="left"
          initialValues={{
            email: currentField.email ? currentField.email : emails && emails.length ? emails[0].email : null,
            fieldType: currentField.fieldType,
            currentValue: currentField.currentValue,
          }}
          id="edit-field-form"
        >
          <Form.Item
            label="Email"
            name={['email']}
            required
            rules={[
              {
                required: true,
                message: 'This field is required.',
              },
            ]}
          >
            <Select getPopupContainer={rootContainer} placeholder="Choose client">
              {getRabbitSignClientOptions(emails, fields)}
            </Select>
          </Form.Item>

          <Form.Item
            label="Field type"
            name={['fieldType']}
            required
            rules={[
              {
                required: true,
                message: 'This field is required.',
              },
            ]}
          >
            <Select getPopupContainer={rootContainer} placeholder="Choose field type">
              {Object.values(rabbitSignFieldTypes)
                .filter((x) => x.value != rabbitSignFieldTypes.none.value)
                .map((rabbitSignFieldType) => (
                  <Select.Option value={rabbitSignFieldType.value} key={rabbitSignFieldType.key}>
                    <Badge color={rabbitSignFieldType.color} /> {rabbitSignFieldType.text}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default EditSettingsModal;
